<template>
  <div class="agent-edit">
    <div class="title">{{ companyName }}</div>

    <Preview ref="preview" :class="['overflow-auto', 'bg-white', isAuditType ? 'audit' : 'edit']" :otherOffset="offset" :agentEdit="true"></Preview>
    
    <div class="buttons" v-if="isAuditType">
      <van-button type="danger" plain @click="refuseDialog = true">拒绝</van-button>
      <van-button type="primary" @click="auditSubmit('pass')">通过</van-button>
    </div>

    <!-- 拒绝原因 -->
    <van-action-sheet v-model="refuseDialog" title="拒绝请填写原因" class="refuse-dialog">
      <van-field
        class="text-input"
        v-model="refusalReason"
        rows="6"
        autosize
        type="textarea"
        placeholder="请输入"
        maxlength="200"
        show-word-limit
      />
      <div class="sub-title">拒绝后，您可联系代理商重新提交申请</div>
      <van-button type="primary" block @click="auditSubmit('refuse')">确定</van-button>
    </van-action-sheet>
  </div>
</template>

<script>
import Preview from './Preview'

export default {
  name: "AgentEdit",
  components: { Preview },
  data() {
    return {
      refuseDialog: false,
      refusalReason: ''
    }
  },
  computed: {
    isAuditType() {
      return this.$bus.params.auditType === '0'
    },
    companyName() {
      return decodeURI(this.$bus.params.companyName)
    },
    offset() {
      if(this.isAuditType) {
        return 68
      }
      return 0
    }
  },
  methods: {
    auditSubmit(status) {
      if(this.refuseDialog && !this.refusalReason) {
        this.$toast.fail('请填写拒绝原因')
        return
      }
      try {
        let data = {
          pass: status === 'pass',
          cause: this.refusalReason
        }
        if (window.wx) {
          wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
              wx.miniProgram.postMessage({ data })
              wx.miniProgram.navigateTo({url: '/features/my/pages/agentLibrary/agentLoading'})
            }
          })
        } else {
          this.$answerUtil.postMessage(data)
        }
      }
      catch(err) {
        console.log(err)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.agent-edit {
  @apply bg-card-bg-gray p-3 h-full box-border;
  .title {
    @apply text-theme-black-850 text-medium-x leading-22 mb-3;
  }
  .audit {
    height: calc(100% - 90px);
  }
  .edit {
    height: calc(100% - 34px);
  }
  .buttons {
    @apply flex mt-3;
    ::v-deep .van-button--primary {
      width: calc(100% - 106px);
    }
    ::v-deep .van-button--plain.van-button--danger {
      width: 94px;
      @apply mr-3 text-red border-red;
    }
  }
  .refuse-dialog {
      @apply px-3 pb-3 w-full box-border;
    .text-input {
      @apply bg-theme-gray;
    }
    .sub-title {
      @apply text-small text-left leading-22  pt-1 pb-3 text-yellow-theme;
    }
  }
}
</style>
